import type { Item, Bundle, ProductCategoryFilter } from 'types';

type SubcategoryDto = {
  displayName: string;
  slug: string;
};

export type CategoryDto = {
  name: string;
  displayName: string;
  categoryFilters: ProductCategoryFilter[];
  slug: string | null;
  subcategories?: SubcategoryDto[];
};

export type CategoryDtoWithSlug = CategoryDto & { slug: string };

export const subcategories = [
  {
    displayName: "Men's Tuxedo Rental",
    slug: 'tuxedos',
  },
  {
    displayName: "Men's Blue Suits and Tuxedos",
    slug: 'blue-suits',
  },
  {
    displayName: "Men's Black Suits and Tuxedos",
    slug: 'black-suits',
  },
  {
    displayName: "Men's Gray Suits and Tuxedos",
    slug: 'gray-suits',
  },
  {
    displayName: "Men's Tan Suits and Tuxedos",
    slug: 'tan-suits',
  },
  {
    displayName: 'Wedding Suits for Rent',
    slug: 'wedding',
  },
  {
    displayName: 'Cocktail Attire Suits for Rent',
    slug: 'cocktail-attire',
  },
  {
    displayName: 'Black Tie Tuxedo Rental',
    slug: 'black-tie',
  },
  {
    displayName: "Semi-Formal Men's Wear for Rent",
    slug: 'semi-formal',
  },
  {
    displayName: 'Beach Wedding Suits for Rent',
    slug: 'beach-wedding',
  },
  {
    displayName: 'Business Formal Suits for Rent',
    slug: 'business-formal',
  },
];

const categories: CategoryDto[] = [
  {
    name: 'preconfigured',
    displayName: 'Tuxedos & Suits',
    categoryFilters: [
      { displayName: 'Tux', value: 'Tux' },
      { displayName: 'Suit', value: 'Suit' },
    ],
    slug: 'tuxedos-and-suits',
    subcategories: subcategories,
  },
  {
    name: 'Shirt',
    displayName: 'Shirts',
    categoryFilters: [
      { displayName: 'Dress Shirts', value: (str: string) => !str.includes('Pleated') },
      { displayName: 'Pleated Shirts', value: 'Pleated' },
    ],
    slug: 'shirts',
  },
  {
    name: 'Tie',
    displayName: 'Ties',
    categoryFilters: [
      { displayName: 'Long', value: (str: string) => !str.includes('Bow') },
      { displayName: 'Bow', value: 'Bow' },
      { displayName: 'Skinny', value: 'Skinny' },
    ],
    slug: 'ties',
  },
  {
    name: 'Vest,Cummerbund',
    displayName: 'Vests & Cummerbunds',
    categoryFilters: [
      { displayName: 'Vest', value: 'Vest' },
      { displayName: 'Cummerbund', value: 'Cummerbund' },
    ],
    slug: 'vests-and-cummerbunds',
  },
  {
    name: 'Shoe',
    displayName: 'Shoes',
    categoryFilters: [],
    slug: null,
  },
  {
    name: 'Pocket Square',
    displayName: 'Pocket Squares',
    categoryFilters: [],
    slug: null,
  },
  {
    name: 'Socks',
    displayName: 'Socks',
    categoryFilters: [],
    slug: null,
  },
  {
    name: 'Belt,Suspenders',
    displayName: 'Belts & Suspenders',
    categoryFilters: [
      { displayName: 'Belt', value: 'Belt' },
      { displayName: 'Suspenders', value: 'Suspenders' },
    ],
    slug: null,
  },
  {
    name: 'Lapel Pin',
    displayName: 'Lapel Pins',
    categoryFilters: [
      { displayName: 'Rose', value: 'Rose' },
      { displayName: 'Carnation', value: 'Carnation' },
    ],
    slug: null,
  },
  {
    name: 'Cufflinks',
    displayName: 'Cufflinks',
    categoryFilters: [],
    slug: null,
  },
  {
    name: 'Tie Bar',
    displayName: 'Tie Bars',
    categoryFilters: [],
    slug: null,
  },
  {
    name: 'Suspenders,Belt,Lapel Pin,Tie Bar,Cufflinks,Pocket Square',
    displayName: 'Accessories',
    categoryFilters: [
      { displayName: 'Tie Bars', value: 'Tie Bar' },
      { displayName: 'Cufflinks', value: 'Cufflinks' },
      { displayName: 'Lapel Pins', value: 'Lapel Pin' },
      { displayName: 'Pocket Squares', value: 'Pocket Square' },
      { displayName: 'Belt', value: 'Belt' },
      { displayName: 'Suspenders', value: 'Suspenders' },
    ],
    slug: 'accessories',
  },
  {
    name: 'Shoe,Socks',
    displayName: 'Shoes & Socks',
    categoryFilters: [
      { displayName: 'Shoes', value: 'Shoe' },
      { displayName: 'Socks', value: 'Socks' },
    ],
    slug: 'shoes-and-socks',
  },
];

export const isValidSubcategory = (category: string, slug: string) => {
  return categories.some((c) => {
    if (c.slug !== category) {
      return false;
    }

    const subcategories = c.subcategories ?? [];

    return subcategories.some((subcategory) => subcategory.slug === slug);
  });
};

export const isSubcategoryPath = (pathname: string) => {
  const parts = pathname.split('/').filter((part) => part.trim() !== '');

  if (parts.length < 3 || parts[0] !== 'collection') {
    return false;
  }

  return isValidSubcategory(parts[1], parts[2]);
};

export default categories;
